<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_9931_22663)">
      <path
        fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C10.5523 0 11 0.447715 11 1C11 1.55228 11.4477 2 12 2H13.1347C13.6323 2 14.0542 2.36593 14.1246 2.85858L15.8389 14.8586C15.925 15.461 15.4575 16 14.849 16H1.15497C0.546423 16 0.0789617 15.461 0.165024 14.8586L1.87931 2.85858C1.94969 2.36593 2.37161 2 2.86926 2H4.00001C4.55229 2 5.00001 1.55228 5.00001 1C5.00001 0.447715 5.44773 0 6.00001 0H10ZM8.75001 4.75C8.75001 4.33579 8.41422 4 8.00001 4C7.5858 4 7.25001 4.33579 7.25001 4.75V5.51373C6.12502 5.63809 5.25001 6.59186 5.25001 7.75C5.25001 8.99264 6.25737 10 7.50001 10H8.50001C8.91422 10 9.25001 10.3358 9.25001 10.75C9.25001 11.1642 8.91422 11.5 8.50001 11.5H6.50001C6.0858 11.5 5.75001 11.8358 5.75001 12.25C5.75001 12.6642 6.0858 13 6.50001 13H7.25001V13.75C7.25001 14.1642 7.5858 14.5 8.00001 14.5C8.41422 14.5 8.75001 14.1642 8.75001 13.75V12.9863C9.875 12.8619 10.75 11.9081 10.75 10.75C10.75 9.50736 9.74265 8.5 8.50001 8.5H7.50001C7.0858 8.5 6.75001 8.16421 6.75001 7.75C6.75001 7.33579 7.0858 7 7.50001 7H9.50001C9.91422 7 10.25 6.66421 10.25 6.25C10.25 5.83579 9.91422 5.5 9.50001 5.5H8.75001V4.75Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_9931_22663">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
